import Handsontable from 'handsontable';

const storeStatusColumn: Handsontable.ColumnSettings = {
  data: 'storeStatus',
  hiddenInPageSettings: true,
  hidden: true,
};

export default storeStatusColumn;
